const WeMediaOptions = {
  weibo: {
    deployType: 0,
    ipConfigUrl: 'http://ip-pool-service-master-starsee.prod.k8s.starsee.it/ip_pool/getIp?num=3&type=2&country=cn'
  },
  twitter: {
    deployType: 1,
    ipConfigUrl: 'http://ip-pool-service-master-starsee.prod.k8s.starsee.it/ip_pool/getIp?num=3&type=2&country=us'
  },
  facebook: {
    deployType: 1,
    ipConfigUrl: 'http://ip-pool-service-master-starsee.prod.k8s.starsee.it/ip_pool/getIp?num=1&type=2&country=global'
  },
  youtube: {
    deployType: 1,
    ipConfigUrl: 'http://ip-pool-service-master-starsee.prod.k8s.starsee.it/ip_pool/getIp?num=1&type=2&country=global'
  }
}

export default WeMediaOptions

export { WeMediaOptions }
